// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1_axp"};